/***
*
*   ACCOUNT NAV
*   Acount sub nav that renders different options based
*   on user permissions. Shows billing & user admin to only account owners
*
**********/

import React from 'react';
import { NavLink } from "react-router-dom";
import './templatesNav.scss';

export function TemplatesNav(props){

  return(
    <nav className='subnav'>

      <NavLink exact to='/templates' activeClassName='active'>Crear Plantilla</NavLink>
      <NavLink exact to='/templates/upload' activeClassName='active'>Cargar Plantilla</NavLink>

    </nav>
  );
}